



















































import DashboardServices from '@/services/dashboard';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { getRange } from '@/libs/time';
@Component
export default class DashboardRank extends Vue {
  dashSrv = new DashboardServices();

  created() {
    this.getDeptSort();
    this.getRuleSort();
  }

  async getDeptSort() {
    let [startTime, endTime] = this.dateA;
    let res = await this.dashSrv.getSort({
      isMore: this.moreA,
      sort: this.sortA,
      sortField: 'ruleOwnerDeptCn',
      startTime,
      endTime
    });
    this.dataSource = res;
  }

  async getRuleSort() {
    let [startTime, endTime] = this.dateB;
    let res = await this.dashSrv.getSort({
      isMore: this.moreB,
      sort: this.sortB,
      sortField: 'ruleSetName',
      startTime,
      endTime
    });
    this.dataSourceB = res;
  }

  radioA: string = 'week';
  dateA: string[] = getRange('week');
  moreA: boolean = false;
  sortA: string = 'desc';
  orderA(sort: string) {
    this.sortA = sort;
    this.getDeptSort();
  }
  changeMoreA() {
    this.moreA = !this.moreA;
    this.getDeptSort();
  }
  @Watch('radioA')
  onRadioAChange() {
    this.dateA = getRange(this.radioA);
  }
  @Watch('dateA')
  onDateAChange() {
    this.getDeptSort();
  }

  radioB: string = 'week';
  dateB: string[] = getRange('week');
  moreB: boolean = false;
  sortB: string = 'desc';
  orderB(sort: string) {
    this.sortB = sort;
    this.getRuleSort();
  }
  changeMoreB() {
    this.moreB = !this.moreB;
    this.getRuleSort();
  }
  @Watch('radioB')
  onRadioBChange() {
    this.dateB = getRange(this.radioB);
  }
  @Watch('dateB')
  onDateBChange() {
    this.getRuleSort();
  }

  columns = [
    { title: '部门', dataIndex: 'name' },
    { title: '预警数量', dataIndex: 'alertCount' },
    { title: '待经办', dataIndex: 'todoHanleCount' },
    { title: '待复核', dataIndex: 'todoReviewCount' },
    {
      title: '操作',
      dataIndex: 'action',
      width: 90,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  dataSource = [];

  columnsB = [
    { title: '决策集', dataIndex: 'name' },
    { title: '预警数量', dataIndex: 'alertCount' },
    { title: '待经办', dataIndex: 'todoHanleCount' },
    { title: '待复核', dataIndex: 'todoReviewCount' },
    {
      title: '操作',
      dataIndex: 'action',
      width: 90,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  dataSourceB = [];

  gotoDetail(field: string, value: string, date: string[]) {
    let [alertDate_ge, alertDate_le] = date;
    this.$router.push({
      path: '/task/full',
      query: {
        [field]: value,
        alertDate_ge,
        alertDate_le
      }
    });
  }
}
